import { capitalize } from 'lodash/fp';

import { DefaultTransactionStatus, TransactionStatus } from 'dashboard/models/transaction-status';
import Sticker, { StickerProps } from 'design-system/components/Sticker';

const DEFAULT_TRANSACTION_STATUS_VARIANT_MAP: Record<
  DefaultTransactionStatus,
  StickerProps['variant']
> = {
  [DefaultTransactionStatus.Approved]: 'success',
  [DefaultTransactionStatus.Created]: 'basic',
  [DefaultTransactionStatus.Declined]: 'danger',
  [DefaultTransactionStatus.NeedsReview]: 'caution',
};

interface TransactionStatusStickerProps {
  transactionStatus: TransactionStatus;
}

export default function TransactionStatusSticker({
  transactionStatus,
}: TransactionStatusStickerProps) {
  const status = transactionStatus?.attributes?.name;
  let variant: StickerProps['variant'] = 'basic';

  if (status in DEFAULT_TRANSACTION_STATUS_VARIANT_MAP) {
    variant = DEFAULT_TRANSACTION_STATUS_VARIANT_MAP[status as DefaultTransactionStatus];
  }
  return <Sticker variant={variant}>{capitalize(status)}</Sticker>;
}
